export default __webpack_public_path__ + "static/media/clock_icon.2c41147b.svg";